import { Chip } from '@mui/material'
import type { ContractStatus } from '@/types'
import { useEnumsStore } from '@/stores/enumsStore'

interface ContractStatusBadgeProps {
  status: ContractStatus
  label?: string
}

const statusConfig: Record<string, { color: 'success' | 'warning' | 'info' | 'error' }> = {
  active: { color: 'success' },
  suspended: { color: 'warning' },
  completed: { color: 'info' },
  cancelled: { color: 'error' },
}

export function ContractStatusBadge({ status, label: labelProp }: ContractStatusBadgeProps) {
  const enums = useEnumsStore((state) => state.enums)
  const labelFromEnums = enums?.ContractStatus?.find((o) => o.value === status)?.label
  const displayLabel = labelProp ?? labelFromEnums ?? status
  const config = statusConfig[status] ?? { color: 'default' as const }
  return (
    <Chip
      label={displayLabel}
      color={config.color}
      size="small"
    />
  )
}
